import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './locales'

import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control

Vue.config.productionTip = false
// 环境变量
Vue.prototype.$env = process.env.NODE_ENV

new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex
  created: bootstrap,
  render: h => h(App)
}).$mount('#container')
